"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtilityBar = void 0;
exports.default = UtilityBarWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _golfToEid = _interopRequireDefault(require("golf-to-eid"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _componentUtilities = require("@ux/component-utilities");
var _reactMintl = require("@godaddy/react-mintl");
var _accountDelegation = _interopRequireDefault(require("@ux/account-delegation"));
var _accountTray = _interopRequireDefault(require("@ux/account-tray"));
var _cartIcon = _interopRequireDefault(require("@px/cart-icon"));
var _help = _interopRequireDefault(require("@ux/icon/help"));
var _link = _interopRequireDefault(require("@ux/link"));
var _logo = _interopRequireDefault(require("@ux/logo"));
var _marketSelector = _interopRequireDefault(require("@ux/market-selector"));
var _productPanel = _interopRequireDefault(require("@ux/product-panel"));
var _accountTray2 = _interopRequireDefault(require("./account-tray/account-tray"));
var _contactTray = _interopRequireDefault(require("./contact-tray"));
var _eid = _interopRequireDefault(require("./eid"));
var _enums = require("./enums");
require("@ux/button/styles");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const assign = Object.assign;
const Notifications = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require( /* webpackChunkName: "notifications" */'@site/notifications'))));

/**
 * Render and expose the Utility as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {React.ReactElement} Namespaced UtilityBar.
 * @api public
 */
class UtilityBar extends _react.Component {
  constructor(props) {
    super(...arguments);

    //
    // Merge `components` from props with the default components so that incoming
    // props only have to set things that should be different than the default.
    //
    this.mergeComponents = (0, _memoizeOne.default)(components => {
      return _objectSpread(_objectSpread({}, _enums.defaultComponents), components);
    });
    this.oldBrand = props.isReseller && props.preset !== 'brand-header' && props.preset !== 'language-header';
    this.eids = {
      blogLink: (0, _eid.default)({
        key: _enums.golf.blogLink,
        manifest: props.manifest
      })
    };
  }

  /**
   * Re-scale the headerNav after username and cart data are available
   *
   * @param {Object} prevProps The previous props for utility-bar
   * @api private
   */
  componentDidUpdate(prevProps) {
    const {
      items,
      cart = {},
      customer
    } = this.props;
    if (this.headerNav && (items !== prevProps.items || cart.items !== (prevProps.cart && prevProps.cart.items) || customer.shopperId !== prevProps.shopperId)) {
      this.headerNav.measureContainer();
      this.headerNav.scale(true);
    }
  }

  /**
   * Prefer state over props when assigning to children
   *
   * @returns {Object} Child props
   * @api private
   */
  getChildProps() {
    return assign({}, this.props, this.state);
  }

  /**
   * Render notifications module
   *
   * @returns {React.ReactElement} Notifications component
   */
  renderNotifications() {
    const props = this.props;
    const {
      urls,
      messages,
      privateLabelId,
      app
    } = props;
    const notificationProps = _objectSpread({
      appKey: app,
      id: 'Notifications',
      showCount: false,
      showOpenCaret: true,
      manifest: props.manifest,
      sso: {
        href: urls.sso.href,
        login: urls.sso.login
      },
      market: props.market,
      shopperId: props.shopperId,
      privateLabelId,
      messages: {
        noNotificationsTitle: messages[_enums.golf.noNotificationsTitle],
        noNotificationsText: messages[_enums.golf.noNotificationsText],
        failedNotificationsTitle: messages[_enums.golf.failedNotificationsTitle],
        failedNotificationsText: messages[_enums.golf.failedNotificationsText],
        failedNotificationsLink: messages[_enums.golf.failedNotificationsLink],
        notificationsError: messages[_enums.golf.notificationsError],
        closeText: messages[_enums.golf.notificationsCloseText],
        headerText: messages[_enums.golf.notificationsHeaderText]
      },
      tooltip: messages[_enums.golf.notificationsHeaderText]
    }, urls.notifications);
    return typeof window !== 'undefined' && /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement("div", {
        className: "notifications-fallback"
      })
    }, /*#__PURE__*/_react.default.createElement(Notifications, notificationProps));
  }
  /**
   * Renders help, notifications, account tray, cart in that order
   * @param  {Object} cartProps  Props specific to cart
   * @param  {Object} childProps Values assembled from combining props and state
   * @returns {React.ReactElement} A right-aligned div containing global elements
   */
  renderGlobalElements(cartProps, childProps) {
    const props = this.props;
    const components = this.mergeComponents(props.components);
    const {
      CartComponent,
      showAccountTrayComponent,
      messages,
      urlArgs,
      urls
    } = props;
    const webMailLinks = [{
      'href': urls.sso.o365Login.href,
      'id': _enums.golf.o365LoginEXP,
      'data-eid': (0, _golfToEid.default)(_enums.golf.o365LoginEXP, {
        prefix: 'uxp.hydra.utility_bar_account_tray',
        postfix: 'link.click'
      }),
      'urlArgs': urlArgs,
      'children': /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: _enums.golf.o365LoginEXP
      })
    }, {
      'href': urls.webmailLogin.href,
      'id': _enums.golf.webmailLoginEXP,
      'data-eid': (0, _golfToEid.default)(_enums.golf.webmailLoginEXP, {
        prefix: 'uxp.hydra.utility_bar_account_tray',
        postfix: 'link.click'
      }),
      'urlArgs': urlArgs,
      'children': /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: _enums.golf.webmailLoginEXP
      })
    }];
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, components.help && this.renderHelpCenter(), components.notifications && props.loggedIn && this.renderNotifications(), components.accountTray && (showAccountTrayComponent ? /*#__PURE__*/_react.default.createElement(_accountTray.default, (0, _extends2.default)({
      bottomLinks: webMailLinks
    }, childProps, {
      messages: messages,
      eidPrefix: "uxp.hyd.utility_bar"
    })) : /*#__PURE__*/_react.default.createElement(_accountTray2.default, childProps)), components.cart && (CartComponent ? /*#__PURE__*/_react.default.createElement(CartComponent, cartProps) : /*#__PURE__*/_react.default.createElement(_cartIcon.default, cartProps)));
  }
  renderHelpCenter() {
    const {
      fullHelpLinkId,
      urlArgs,
      urls,
      supportContacts: {
        technicalSupportDescription,
        technicalSupportPhone
      } = {}
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: fullHelpLinkId
    }, title => /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      "data-eid": "uxp.hyd.utility_bar.help.link.click",
      className: "help-link",
      urlArgs: urlArgs
    }, urls.help, {
      target: "_blank",
      title: title,
      "aria-label": technicalSupportDescription + ' ' + technicalSupportPhone
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "help-icon"
    }, /*#__PURE__*/_react.default.createElement(_help.default, null)), /*#__PURE__*/_react.default.createElement("span", {
      className: "help-link-text"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: fullHelpLinkId
    }))));
  }

  /**
   * Render function for jsx specific to DeepSee
   * @param  {Object} logoProps  Props specific to logo
   * @param  {Object} cartProps  Props specific to cart
   * @param  {Object} childProps Values assembled from combining props and state
   * @returns {React.ReactElement} div for seechange elements
   */
  renderDeepSee(logoProps, cartProps, childProps) {
    const props = this.props;
    const components = this.mergeComponents(props.components);
    const {
      messages,
      urls,
      urlArgs,
      privateLabelId
    } = props;
    const isNew123Reg = privateLabelId === 587240;
    const {
      features
    } = childProps;
    const control = /*#__PURE__*/_react.default.createElement("span", {
      className: "product-flyout-btn-lines"
    });
    const productPanelProps = {
      control,
      messages,
      urls,
      discoverNav: props.discoverNav,
      productNav: props.navigation,
      urlArgs,
      globalElements: false
    };
    const marketSelectorProps = assign({
      currentPage: props.currentPage,
      manifest: props.manifest,
      eidPrefix: 'uxp.hyd',
      urls,
      urlArgs,
      messages,
      currentMarket: props.market,
      numColumns: props.breakpoint === 'tablet' ? 2 : 4,
      marketData: props.marketData,
      isReseller: props.isReseller
    }, props.marketSelector);
    const eids = this.eids;
    const contactTrayProps = assign({
      contactTrayEnabled: features.contactTray,
      utilityChatEnabled: features.utilityChat,
      requestACallEnabled: features.requestACall,
      shopperId: props.customer.shopperId
    }, props);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "see-change-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "see-change-bar-left"
    }, components.logo && /*#__PURE__*/_react.default.createElement("div", {
      className: "topnav-logo-wrap"
    }, /*#__PURE__*/_react.default.createElement(_logo.default, logoProps)), components.marketSelector && !isNew123Reg && /*#__PURE__*/_react.default.createElement("div", {
      className: "market-selector-container"
    }, /*#__PURE__*/_react.default.createElement(_marketSelector.default, marketSelectorProps)), components.productPanel && /*#__PURE__*/_react.default.createElement(_productPanel.default, productPanelProps)), /*#__PURE__*/_react.default.createElement("div", {
      className: "see-change-bar-right"
    }, components.contactTray && /*#__PURE__*/_react.default.createElement(_contactTray.default, contactTrayProps), components.blog && props.urls.blog && /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      className: "blog-link",
      urlArgs: props.urlArgs
    }, props.urls.blog, {
      "data-eid": eids.blogLink
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.blogLink
    })), this.renderGlobalElements(cartProps, childProps)));
  }

  /**
   * Render function for jsx in all non-deepsee instances of utility-bar
   * @param  {Object} logoProps  Props specific to logo
   * @param  {Object} cartProps  Props specific to cart
   * @param  {Object} childProps Values assembled from combining props and state
   * @returns {React.ReactElement} div for normal rendering of elements
   */
  renderOldBrand(logoProps, cartProps, childProps) {
    const props = this.props;
    const components = this.mergeComponents(props.components);
    const {
      CartComponent,
      privateLabelId
    } = props;
    const isNew123Reg = privateLabelId === 587240;
    const eids = this.eids;
    const {
      features
    } = childProps;
    const marketSelectorProps = assign({
      currentPage: props.currentPage,
      manifest: props.manifest,
      eidPrefix: 'uxp.hyd',
      urls: props.urls,
      urlArgs: props.urlArgs,
      messages: props.messages,
      currentMarket: props.market,
      numColumns: props.breakpoint === 'tablet' ? 2 : 4,
      marketData: props.marketData,
      isReseller: props.isReseller
    }, props.marketSelector);
    const contactTrayProps = assign({
      contactTrayEnabled: features.contactTray,
      utilityChatEnabled: features.utilityChat,
      shopperId: props.customer.shopperId
    }, props);
    const utilSeparator = /*#__PURE__*/_react.default.createElement("div", {
      className: "util-separator"
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "utility-bar-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "utility-left-nav"
    }, components.logo && /*#__PURE__*/_react.default.createElement("div", {
      className: "topnav-logo-wrap"
    }, /*#__PURE__*/_react.default.createElement(_logo.default, logoProps))), /*#__PURE__*/_react.default.createElement("div", {
      className: "utility-right-nav"
    }, components.utilitySeparator && props.isPaymentHeader && utilSeparator, components.contactTray && /*#__PURE__*/_react.default.createElement(_contactTray.default, contactTrayProps), components.marketSelector && !isNew123Reg && /*#__PURE__*/_react.default.createElement(_marketSelector.default, marketSelectorProps),
    // if there is no props.urls.blog, then blog is blacklisted
    components.blog && props.urls.blog && /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      className: "blog-link",
      urlArgs: props.urlArgs
    }, props.urls.blog, {
      "data-eid": eids.blogLink
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.blogLink
    })), components.help && this.renderHelpCenter(), components.utilitySeparator && props.loggedIn && utilSeparator, components.notifications && props.loggedIn && this.renderNotifications(), components.utilitySeparator && !props.isPaymentHeader && utilSeparator, components.utilitySeparator && props.isPaymentHeader && !props.loggedIn && utilSeparator, components.accountTray && /*#__PURE__*/_react.default.createElement(_accountTray2.default, (0, _extends2.default)({}, childProps, {
      oldBrand: true
    })), components.cart && (CartComponent ? /*#__PURE__*/_react.default.createElement(CartComponent, cartProps) : /*#__PURE__*/_react.default.createElement(_cartIcon.default, cartProps))));
  }

  /**
   * Renders utility-bar
   * @returns {React.ReactElement} the whole utility-bar
   */
  render() {
    var _props$features;
    const props = this.props;
    const {
      logos,
      isReseller,
      resellerStorefrontLogoSize,
      app
    } = props;
    const components = this.mergeComponents(props.components);
    const childProps = this.getChildProps();
    const {
      features
    } = childProps;
    const marketInfo = props.marketData[props.market];
    const isPrivateLabel = props.privateLabelId !== 1;
    this.countryName = marketInfo ? marketInfo.countryName : 'United States';

    // Only apply logo size class name on reseller storefront for private
    // labels with a desktop logo and a size setting other than 'small'.
    const plLogoSize = isReseller && isPrivateLabel && logos && logos.desktop && resellerStorefrontLogoSize && resellerStorefrontLogoSize !== 'small' && `pl-${resellerStorefrontLogoSize}-logo`;
    const showCountryNameOnLogo = (0, _componentUtilities.isMobile)(props.breakpoint) || props.breakpoint === 'tablet' ? false : ((_props$features = props.features) === null || _props$features === void 0 ? void 0 : _props$features.showCountryNameOnLogo) || false;
    const logoProps = assign({
      'className': (0, _classnames.default)('topnav-logo', props.tempLogo && 'temp-logo-anchor', plLogoSize),
      'showCountryNameOnLogo': showCountryNameOnLogo,
      'country': this.countryName,
      'href': props.urls.home.href,
      'logos': props.logos,
      'market': props.market,
      'messages': props.messages,
      'privateLabelId': props.privateLabelId,
      'privateLabelName': props.privateLabelName,
      'urlArgs': props.urlArgs,
      'tempLogo': props.tempLogo,
      'urls': props.urls,
      'data-eid': 'uxp.hyd.utility_bar.logo.link.click'
    }, props.logo);
    const cartProps = assign({
      appKey: app,
      manifest: props.manifest
    }, props.cart);
    if (typeof this.props.items === 'number') {
      cartProps.items = this.props.items;
    }

    // isReseller comes from sales-header
    // isPrivateLabel must be calculated for utility-header
    const utilityBarClasses = (0, _classnames.default)({
      'utility-bar': this.oldBrand,
      'single-use-header': components.logo && !props.isPaymentHeader && this.oldBrand,
      'payment-header': props.isPaymentHeader,
      'pl': isPrivateLabel,
      'pl-no-logo': isPrivateLabel && (!logos || !((0, _componentUtilities.isMobile)(props.breakpoint) ? logos.mobile : logos.desktop)),
      'reseller': isReseller,
      'language-header': props.preset === 'language-header',
      'brand-header': props.preset === 'brand-header',
      'logged-in': props.loggedIn,
      'see-change-bar': !this.oldBrand,
      'reseller-sales-header': props.preset === 'reseller-sales-header'
    });
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement("div", null, (components.accountDelegation || features.showAccountDelegation) && /*#__PURE__*/_react.default.createElement(_accountDelegation.default, {
      market: props.market,
      messages: props.messages,
      action: props.urls.sso.exitDelegation.href,
      restoreCookie: props.urls.sso.restoreCookie.href,
      customer: props.customer
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: utilityBarClasses
    }, this.oldBrand ? this.renderOldBrand(logoProps, cartProps, childProps) : this.renderDeepSee(logoProps, cartProps, childProps))));
  }
}
exports.UtilityBar = UtilityBar;
UtilityBar.propTypes = {
  app: _propTypes.default.string,
  components: _propTypes.default.shape({
    marketSelector: _propTypes.default.bool,
    contactTray: _propTypes.default.bool,
    help: _propTypes.default.bool,
    notifications: _propTypes.default.bool,
    accountTray: _propTypes.default.bool,
    cart: _propTypes.default.bool,
    blog: _propTypes.default.bool,
    logo: _propTypes.default.bool
  }),
  CartComponent: _propTypes.default.elementType,
  contactTray: _propTypes.default.object,
  currentHref: _propTypes.default.string,
  customer: _propTypes.default.object.isRequired,
  discoverNav: _propTypes.default.array,
  eidPrefix: _propTypes.default.string,
  features: _propTypes.default.shape({
    showContactTrayForHelpCenter: _propTypes.default.bool,
    showCountryNameOnLogo: _propTypes.default.bool
  }).isRequired,
  loggedIn: _propTypes.default.bool,
  manifest: _propTypes.default.string,
  market: _propTypes.default.string.isRequired,
  marketSelector: _propTypes.default.object,
  marketData: _propTypes.default.object,
  messages: _propTypes.default.object.isRequired,
  navigation: _propTypes.default.array,
  privateLabelId: _propTypes.default.number,
  privateLabelName: _propTypes.default.string,
  showAccountTrayComponent: _propTypes.default.bool,
  supportContacts: _propTypes.default.object,
  tempLogo: _propTypes.default.object,
  urlArgs: _propTypes.default.object,
  urls: _propTypes.default.object.isRequired,
  utilityBarNav: _propTypes.default.arrayOf(_propTypes.default.object),
  isPaymentHeader: _propTypes.default.bool,
  isReseller: _propTypes.default.bool,
  fullHelpLinkId: _propTypes.default.string,
  resellerStorefrontLogoSize: _propTypes.default.string,
  preset: _propTypes.default.string,
  items: _propTypes.default.number,
  cart: _propTypes.default.object,
  shopperId: _propTypes.default.string,
  featuredNav: _propTypes.default.array,
  currentPage: _propTypes.default.string,
  logos: _propTypes.default.object,
  logo: _propTypes.default.object,
  breakpoint: _propTypes.default.string.isRequired
};
UtilityBar.defaultProps = {
  utilityBarNav: [],
  components: _enums.defaultComponents,
  contactTray: {
    compact: true
  },
  features: {},
  privateLabelId: 1,
  privateLabelName: '',
  isPaymentHeader: false,
  isReseller: false,
  marketData: {},
  fullHelpLinkId: _enums.golf.helpLink,
  scaleFeaturedNav: false,
  eidPrefix: 'uxp.hyd.featured_nav'
};
function UtilityBarWrapper(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)('mobile', 'phablet', 'tablet', 'desktop', 'large');
  return /*#__PURE__*/_react.default.createElement(UtilityBar, (0, _extends2.default)({
    breakpoint: breakpoint
  }, props));
}